import { render, staticRenderFns } from "./CustomerBoxList.vue?vue&type=template&id=1025c2be&scoped=true"
import script from "./CustomerBoxList.vue?vue&type=script&lang=js"
export * from "./CustomerBoxList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1025c2be",
  null
  
)

export default component.exports